import { proxyRequest, ProxyRequestOpt } from './request'
import * as ApiTypes from './types'
import { getAgentDomain } from '@/servers/config'

const domain = getAgentDomain()

export const chatCustomURLAPI = async (args: {
  body: unknown
  customUrl?: string
  opt?: ProxyRequestOpt
}) => {
  return proxyRequest({
    url: args.customUrl,
    ...args.opt,
    body: args.body
  })
}

export const chatCompletionAPI = async (args: {
  body: {
    intention?: string
    images?: string[]
    content?: string
  }
  opt?: ProxyRequestOpt
}) => {
  return proxyRequest({
    url: domain + '/ai_agent/market/chat/completion',
    ...args.opt,
    body: args.body
  })
}

export const saveUserProfileAPI = (args: {
  body: ApiTypes.UserProfileReqsArgs
  opt?: ProxyRequestOpt
}) => {
  return proxyRequest({
    url: domain + '/ai_agent/v1/profile/save',
    ...args.opt,
    body: args.body
  })
}

export const videoGenerateAPI = async (args: { body?: undefined; opt?: ProxyRequestOpt }) => {
  return proxyRequest({
    url: domain + '/ai_agent/market/video/gene',
    ...args.opt,
    body: args.body
  })
}

export const getAdDataAPI = (args: unknown) => {
  return proxyRequest({
    url: domain + '/ai_agent/market/ad/data',
    body: args
  })
}

export const submitAdAPI = (args: unknown) => {
  return proxyRequest({
    url: domain + '/ai_agent/market/ad/submit',
    body: args
  })
}

export interface VideoProductImagesItem {
  image_url: string
  has_face: boolean
}

export const geneCreativeDescAPI = (args: {
  body: {
    product_info: {
      category: string
      product_name: string
      selling_point: string
      target_audience: string
      sales_region: string
      sales_language?: string
    }
    message_id: string
    content?: string
    images: VideoProductImagesItem[]
  }
  opt?: ProxyRequestOpt
}) => {
  return proxyRequest({
    url: domain + '/ai_agent/market/creative/gene_desc',
    ...args.opt,
    body: args.body
  })
}

export type VideoCreateRatio = '1:1' | '11:1' | '16:9' | '4:3' | '9:16'
export type VideoCreateScriptMode = 'same_script' | 'variant_script'

export const createVideoAPI = (args: {
  body: {
    count: number
    duration: number
    language?: string
    message_id?: string
    product_desc: string
    product_images: VideoProductImagesItem[]
    ratio: VideoCreateRatio
    sales_region?: string
    script_mode?: VideoCreateScriptMode
  }
  opt?: ProxyRequestOpt
}) => {
  return proxyRequest({
    url: domain + '/ai_agent/market/video/create',
    ...args.opt,
    body: args.body
  })
}
